import lessRequire from '../../../../config/less-require-resolver';
import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import cn from 'classname';

import isArray from 'lodash/isArray';
import map from 'lodash/map';
import some from 'lodash/some';

import Animate from '../../../shared/animation';
import { showMoreRowsDiv } from '../../../shared/table-helpers';
import {
	getOfferLangs,
	isAccessGranted,
	isWaitingForActivation,
	isAccessRejected,
	showOfferBoostText,
	checkWasBoostedOffer
} from '../../shared';

import GeoGoalsTable from './geo-goals';
import BoosterInfoBanner from './booster-info-banner';
import IdPopup from './../popups/IdPopup';

lessRequire('modules/offers/components/table/main.less');

const isRocket = process.env.CPA_ENV === 'rocket';

const OffersTable = ({
	tableRows,
	tableHeaders,
	activeOfferData,
	sortByColumn,
	setUnClickableLink,
	columnSorting,
	intl,
	showMore,
	isCanNotMoveToNext,
	filterByCategory,
	tableId,
	lists,
	user,
	affiliateLevels,
	toggleRules,
	boost,
	managerData,
	userIsMaster
}) => (
	<Animate>
		<div className="dashboard-table offers-half-width"
			key={tableId}
			style={!userIsMaster && !isRocket ? {paddingTop: '60px'}:{}}
		>
			{rows(
				tableRows, filterByCategory, setUnClickableLink,
				intl, lists, user, affiliateLevels,
				toggleRules, boost, userIsMaster, managerData, activeOfferData
			)}
			{!isCanNotMoveToNext && tableRows.length && showMore ? showMoreRowsDiv(showMore, 'OffersTable', intl) : null}
		</div>
	</Animate>
);

OffersTable.propTypes = {
	tableRows: PropTypes.array,
	tableHeaders: PropTypes.array,
	sortByColumn: PropTypes.func,
	columnSorting: PropTypes.object,
	intl: PropTypes.func,
	showMore: PropTypes.func,
	setUnClickableLink: PropTypes.func,
	isCanNotMoveToNext: PropTypes.bool,
	filterByCategory: PropTypes.func,
	tableId: PropTypes.number,
	lists: PropTypes.object,
	user: PropTypes.object,
	affiliateLevels: PropTypes.object,
	toggleRules: PropTypes.func,
	boost: PropTypes.func,
	userIsMaster: PropTypes.bool
};

const rows = (
	tableRows, filterByCategory, setUnClickableLink,
	intl, lists, user, affiliateLevels, toggleRules, boost, userIsMaster, managerData, activeOfferData
) => {
	if (!tableRows.length)
		return (
			<tr key={1} className="not-found">
				<th colSpan='16'>
					<span>{intl('Не найдено подходящих офферов. Попробуйте еще.')}</span>
				</th>
			</tr>
		);

	return tableRows.map(item => {
		const offerLangs = getOfferLangs(item, lists['landing-languages'], intl);
		const areAllLocationBoostersUnavailable = !some(item.goals, { isBoosterAvailable: true });
		const shouldShowBooster =
			!checkWasBoostedOffer(user.boost_info, item) &&
			showOfferBoostText(item) &&
			!isWaitingForActivation(item) &&
			!isAccessRejected(item) &&
			!areAllLocationBoostersUnavailable &&
			!user.is_master;

		const isNeedShowIdFrame = item.goals.some(gl => gl.locationCountryCode === 'ID');

		const activeOfferItem = activeOfferData && activeOfferData
			.filter(actOff => Number(item.id) === Number(actOff.offer_id));

		return (
			<Link
				className="hover-active"
				to={!item.uncklickable_link ? `offers/${item.id}` : null}
				onClick={() => {
					if (isRocket) {
						window.dataLayer = window.dataLayer || [];
						window.dataLayer.push({ event: 'view_offer' });
					}
				}}
				key={item.id}
			>
				<div className="border">
					<div className="tr" key={item.id}>
						<div className={cn('preview', item.is_exclusive && 'is-exclusive')}>
							<img src={item.image ? item.image : '//placehold.it/80x80'} alt={item.title} />
						</div>
						<div className="title">
							{!!item.is_new && <span className="button mark font-proxima-nova-semibold">{intl('новинка')}</span>}
							{!!item.access_on_request && <span className="button mark access font-proxima-nova-semibold">
								{intl('по запросу')}</span>}
							<h3 className="font-proxima-nova-semibold">
								<span>{item.title}</span>
							</h3>
							<p className="subtitle">{item.subtitle}</p>
							{activeOfferItem && !!activeOfferItem.length && <h4>{ intl('Рекомендованая аудитория:') }</h4>}
							{
								activeOfferItem && activeOfferItem
									.map((actOff, indx) =>
										<p className="subtitle" key={indx}>
											{actOff.country_name} {actOff.target_audience}
										</p>
									)
							}
						</div>
						{
							isRocket &&
							<div className={cn('category', (!!item.is_new || !!item.access_on_request) && 'is-new-row')}>
								<p className="category__label">{intl('Категория:')}</p>
								<span
									className={cn('category__text', (!!item.is_new || !!item.access_on_request) && 'is-new-row')}
									onClick={e => {
										e.preventDefault();
										filterByCategory(item.category);
									}}
								>
									{item.category_rp}
								</span>
							</div>
						}
						{ isNeedShowIdFrame && <IdPopup intl={intl} managerData={managerData}/> }
						<div className={cn({
							'description': true,
							'is-new-row': (!!item.is_new || !!item.access_on_request),
							'is-showed-id-frame': isNeedShowIdFrame
						})}
						/>
						<div className="langs-children-container">
							{offerLangs.offerLangsLen > 0 ? (
								<div className={cn('offer-langs', (!!item.is_new || !!item.access_on_request) && 'is-new-row')}>
									{offerLangs.offerLangsLen > 1 ? (
										<div>
											<span className="count">{offerLangs.offerLangsLen}</span>
											<div className="text">{offerLangs.offerLangsWord}</div>
											<div className="hover-popup">
												{map(offerLangs.offerLangs, l => (
													<span key={`${item.id}${l}`} className="lang">
														{l}
													</span>
												))}
											</div>
										</div>
									) : (
										<div className="text">{offerLangs.offerLangs[0]}</div>
									)}
								</div>
							) : null}
							{userIsMaster &&
								item.child_affiliates &&
								item.child_affiliates.length && (
								<div className="child-affiliates-count">{item.child_affiliates.length}</div>
							)}
						</div>
					</div>
					<div className="info-row">
						<div className="info-row__table-geo">
							{isArray(item.goals) && (
								<GeoGoalsTable
									data={item.goals}
									intl={intl}
									boost={boost}
									user={user}
									offer={item}
									toggleRules={toggleRules}
									setUnClickableLink={setUnClickableLink}
								/>
							)}
						</div>
						<div className={cn({
							'booster-buttons-wrap': true,
							'float-right': !shouldShowBooster
						})}>
							<BoosterInfoBanner intl={intl} shouldShowBooster={shouldShowBooster} offerData={item} />
							<div
								className={cn({
									'offer-buttons-wrap': true
								})}
							>
								{addOfferControl(item, toggleRules, intl, user, affiliateLevels)}
								{isAccessGranted(item) && (
									<Link
										className="button yellow-btn font-proxima-nova-semibold boost-btn"
										to={`campaigns/new/${item.id}/`}
									>
										{intl('Создать поток')}
									</Link>
								)}
								{isWaitingForActivation(item) && (
									<p className="control-btn__info font-proxima-nova-semibold">{intl('Ожидается активация')}</p>
								)}

								{isAccessRejected(item) && (
									<p className="control-btn__info font-proxima-nova-semibold">{intl('Заявка отклонена')}</p>
								)}
							</div>
						</div>
					</div>
				</div>
			</Link>
		);
	});
};

const addOfferControl = (item, toggleRules, intl, user, affiliateLevels) => {
	if (item && !item.available && !item.offer_access_thread_id) {
		return (
			<button className="button yellow-btn font-proxima-nova-semibold boost-btn" onClick={e => {
				e.preventDefault();
				toggleRules(item.id);
			}}>
				{(
					user.level === affiliateLevels.noob ||
					item.access_on_request) ? intl('Запросить доступ') : intl('Подключить оффер')}
			</button>
		);
	}
};

addOfferControl.propTypes = {
	data: PropTypes.object,
	user: PropTypes.object,
	addOffer: PropTypes.func,
	intl: PropTypes.func,
	affiliateLevels: PropTypes.object,
	toggleRules: PropTypes.func
};

export default OffersTable;



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/offers/components/table/main.js